//////////////////////////////////////////////////////////////////////////////////////   IMPORT
///////////////////////////////////////////////////////////   REACT
import React from 'react';
///////////////////////////////////////////////////////////   LIBS
import Table from 'react-bootstrap/Table';
///////////////////////////////////////////////////////////   SCSS
import './video-playlist.styles.scss';
///////////////////////////////////////////////////////////   FONTAWESOME
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { faPlayCircle } from '@fortawesome/free-solid-svg-icons';

//////////////////////////////////////////////////////////////////////////////////////    CLASS SETUP
class VideoPlaylist extends React.Component<any, { [key: string]: any }> {
  constructor(props: any) {
    super(props);
    this.state = {
      mainVideo: JSON.parse(JSON.stringify(this.props.mainVideo))
    };
  }
  ///////////////////////////////////////////////////////////   CLASS METHODS
  /**
   * Handle playlist
   * @param url
   */
  private handlePlaylistIn = (url: string): void => {
    this.props.handlePlaylistExt(url);
  };

  /**
   * Print playlist
   * @returns JSX Element table body and playlist rows
   */
  private printVidList = (): JSX.Element => {
    const playL = JSON.parse(JSON.stringify(this.props.playList)),
      { mainVideo } = this.state;
    let arr: any[] = [],
      thumbnail: string,
      playlistElementTitle: string,
      playlistButtonSecondaryTitle: string;
    playL.unshift(mainVideo);
    // TODO:: sos refactor
    if (playL) {
      // eslint-disable-next-line
      playL.map((datar: any, key: number) => {
        // eslint-disable-next-line
        datar.program.map((val: any, index: number) => {
          //if (val.id === 'playlistButtonTitle' || val.id === 'thumbnailUrl') {
          if (val.id === 'playlistButtonTitle' && val.show) {
            playlistElementTitle = val.data;
          } else if (val.id === 'thumbnailUrl' && val.show) {
            thumbnail = val.data;
          } else if (val.id === 'thumbnailUrl' && !val.show) {
            thumbnail = ' ';
          }
          if (val.id === 'playlistButtonSecondaryTitle' && val.show) {
            playlistButtonSecondaryTitle = val.data;
          }
          //}
        });
        arr.push(
          <tr key={'playlist_elem_' + key}>
            <td className='playlist-element'>
              <div className='playlist-element-item' onClick={() => this.handlePlaylistIn({ playListActivatedBtn: 'videoUrlList_' + key, ...datar })}>
                <div className='playlist-item-thumbnail'>
                  <img src={thumbnail} alt={''} />
                  <span className='playlist-item-icon'>
                    <FontAwesomeIcon icon="play-circle" />
                  </span>
                </div>
                <div>
                  <div className='playlist-text'>{playlistElementTitle}</div>
                  {playlistButtonSecondaryTitle && <div className='playlistBtnSecondaryTitle'>{playlistButtonSecondaryTitle}</div>}
                </div>
              </div>
            </td>
          </tr>
        );
      });
    }
    return <tbody>{arr}</tbody>;
  };
  ///////////////////////////////////////////////////////////   RENDER
  render() {
    return (
      <Table>
        <this.printVidList />
      </Table>
    );
  }
}
export default VideoPlaylist;
